import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6df8479f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resume_contents_wrapper" }
const _hoisted_2 = { class: "resume_layout_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "company_text" }, "編集したい職歴を選んでください", -1))
const _hoisted_4 = { class: "entry_career_company_badge" }
const _hoisted_5 = { class: "entry_career_company_name" }
const _hoisted_6 = { class: "entry_career_company_businesstype" }
const _hoisted_7 = { class: "entry_career_company_button" }
const _hoisted_8 = {
  key: 0,
  class: "entry_career_company_button_delete"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "entry_career_company_button_edit" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"company_annotation\" data-v-6df8479f><p class=\"company_annotation_text\" data-v-6df8479f><span class=\"company_annotation_text_clause\" data-v-6df8479f>ご応募いただいた企業に提出するキャリアシートには</span><span class=\"company_annotation_text_clause\" data-v-6df8479f>直近3社の職歴が記載されます。</span></p><p class=\"company_annotation_text\" data-v-6df8479f><span class=\"company_annotation_text_clause\" data-v-6df8479f>3社目より前の職歴は別途提出いただく</span><span class=\"company_annotation_text_clause\" data-v-6df8479f>履歴書・職務経歴書に詳細をご記入ください。</span></p></div>", 1)
const _hoisted_13 = { class: "company_edit_button" }
const _hoisted_14 = { class: "company_edit_button_back" }
const _hoisted_15 = { class: "company_edit_button_add" }

import BaseButton from '@/components/BaseButton.vue';
import BaseThreeButtonModal from '@/components/BaseThreeButtonModal.vue';
import Loading from '@/components/Loading.vue';
import { ref, Ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import store from '@/store';
import { DisplayWorkHisInfoItem } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const isLoading = ref(false);

const displayWorkHisInfoList: Ref<DisplayWorkHisInfoItem[]> = computed(() => {
  return store.getters['workHistory/displayWorkHisInfoList'] || [];
});

/** 削除するID */
const deleteBusicrId: Ref<number | null> = ref(null);
const deleteWorkHistory = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('workHistory/deleteWorkHistoryInfo', deleteBusicrId.value);
    init();
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
    closeDeleteConfirmModal();
  }
};

const shownDeleteConfirmModal = ref(false);

const openDeleteConfirmModal = (busicrId: number) => {
  shownDeleteConfirmModal.value = true;
  deleteBusicrId.value = busicrId;
};

const closeDeleteConfirmModal = () => {
  shownDeleteConfirmModal.value = false;
  deleteBusicrId.value = null;
};

const init = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('workHistory/getWorkHistoryInfo');
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e30', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n30' });
  }
};

const transitionAddWorkHistoryPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e35', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e35' });
  }
};

const transitionEditWorkHistory = async (busicrId: number, i: number) => {
  isLoading.value = true;
  store.commit('workHistory/setEditingBusicrId', busicrId);
  // 編集する職歴が直近か否か
  if (i === 0) {
    store.commit('workHistory/setIsMostRecent', true);
  } else {
    store.commit('workHistory/setIsMostRecent', false);
  }
  await store.dispatch('workHistory/getWorkHistoryDetailInfo', busicrId), (isLoading.value = false);
  if (route.query.ref === 'e') {
    router.push({ name: 'e34', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e34' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayWorkHisInfoList), (displayWorkHisInfo, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "entry_career_company",
            key: displayWorkHisInfo.busicrId
          }, [
            _createElementVNode("div", _hoisted_4, "職歴" + _toDisplayString(i + 1), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(displayWorkHisInfo.compname), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(displayWorkHisInfo.indsctgName), 1),
            _createElementVNode("div", _hoisted_7, [
              (_unref(displayWorkHisInfoList).length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "button_company_delete",
                      onClick: ($event: any) => (openDeleteConfirmModal(displayWorkHisInfo.busicrId))
                    }, "この職歴を削除", 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "button_company_edit",
                  onClick: ($event: any) => (transitionEditWorkHistory(displayWorkHisInfo.busicrId, i))
                }, "この職歴を編集", 8, _hoisted_11)
              ])
            ])
          ]))
        }), 128)),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(BaseButton, {
            theme: "tertiary",
            onClick: transitionPreviousPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(BaseButton, {
            theme: "primary",
            onClick: transitionAddWorkHistoryPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("＋さらに職歴を追加する")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (shownDeleteConfirmModal.value)
      ? (_openBlock(), _createBlock(BaseThreeButtonModal, {
          key: 0,
          leftBtnText: "キャンセル",
          rightBtnText: "削除する",
          onLeftBtnClick: closeDeleteConfirmModal,
          onRightBtnClick: deleteWorkHistory
        }, {
          large: _withCtx(() => [
            _createTextVNode("削除します。よろしいですか？")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})